import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@material-ui/core';
import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons';
import ReadOnlyJsonObjectView from 'Components/UI/ReadOnlyJsonObjectView';

const styles = theme => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
    marginTop: theme.spacing(2),
  },
  status: {
    display: 'flex',
    flexFlow: 'row',
    flex: 1,
    justifyContent: 'space-between',
  },
});

const View = ({
  classes, status, statusColor, jsonObject, amplitudeRootNodeProps, onClickAccordion,
}) => {
  return (
    <Box className={classes.root} debugColor="chartreuse" {...amplitudeRootNodeProps}>
      <Accordion
        square
        component={Box}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          onClick={onClickAccordion}
        >
          <Box className={classes.status}>
            <Typography variant="h6">
              Account Info
            </Typography>
            <Typography
              variant="h6"
              style={{ color: statusColor.backgroundColor }}
            >
              {status}
            </Typography>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <ReadOnlyJsonObjectView jsonObject={jsonObject} />
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

View.propTypes = {
  classes: PropTypes.object.isRequired,
  status: PropTypes.string.isRequired,
  statusColor: PropTypes.string.isRequired,
  jsonObject: PropTypes.object.isRequired,
  amplitudeRootNodeProps: PropTypes.object.isRequired,
  onClickAccordion: PropTypes.func.isRequired,
};

export default withStyles(styles)(View);
